<template>
  <div class="nav-cont" ref="dropdownRef" :class="{ shadow: !isShadowVisible }">
    <div class="d-flex-s" style="width: 100%">
      <div class="nav--coo">
        <img src="../assets/img/otgame/log-left.png" height="30" />
        <!-- <div
          @click="show = !show"
          class="m-r-10"
          style="background: #33363d; border-radius: 8px; padding: 6px 7px"
        > -->
        <!-- <div
          @click="goOpen()"
          class="nav--gn m-r-10"
          :class="{ 'tran-xz': show }"
        ></div> -->
        <!-- 
        <div v-if="token" class="sidedrawer-top">
          <img
            :src="
              require(`@/assets/img/vip/V${
                InitDate.vipLevel ? InitDate.vipLevel : 0
              }.png`)
            "
            height="28"
            style="position: absolute"
          />
          <img
            src="../assets/img/otgame/vipgif.gif"
            height="28"
            style="position: absolute"
          />
        </div> -->

        <div
          v-if="!token && !isSingleCountry"
          class="topnav-country-wrap"
        >
          <div
            class="d-flex"
            style="
              justify-content: center;
              background: rgba(0, 0, 0, 0.6);
              border-radius: 3px;
              padding: 7px 10px;
              cursor: pointer;
            "
            @click="toggleCountryDrop"
          >
            <img :src="GET_ICONURL" width="25" />
            <span class="m-l-5 m-r-5">{{ GET_COUNTRYNAME }}</span>
            <van-icon :name="showCountryDrop ? 'arrow-up' : 'arrow-down'" />
          </div>
          <div v-if="showCountryDrop" class="topnav-country-dropdown">
            <div
              v-for="(item, idx) in countryList"
              :key="idx"
              class="topnav-country-dropdown__item"
              @click="selectCountryNav(item)"
            >
              <img :src="item.iconUrl" width="24" />
              <span>{{ item.countryName }}</span>
              <span style="margin-left: auto; color: var(--vk-brand); font-size: var(--vk-fs-xs); font-weight: 600;">{{ item.areaCode }}</span>
            </div>
            <div v-if="countryList.length === 0" class="topnav-country-dropdown__item" style="justify-content: center; color: var(--vk-t3);">
              Loading...
            </div>
          </div>
        </div>
        <!-- </div> -->

        <!-- <img src="../assets/img/common/logo_h.png" height="46" /> -->
        <!-- <div class="nav--log"></div> -->
      </div>
      <div class="nav--coe" :key="timer">
        <div v-if="token" class="nav--ct">
          <div
            class="d-flex nav-coe-ll"
            style="background: rgba(0, 0, 0, 0.3); padding-left: 5px"
          >
            <div class="balance-text d-flex">
              {{ GET_CURRENCYUNIT }}
              <div class="m-l-10 m-r-5">
                <p style="color: var(--vk-gold)">
                  {{ $formatNumberWithCommas(InitDate2.balance) }}
                </p>
                <p>{{ $formatNumberWithCommas(InitDate2.promoBalance) }}</p>
              </div>
            </div>
            <span
              class="vk-touch-44"
              role="button"
              aria-label="refresh balance"
              @click="toggleRotation"
            >
              <img
                :class="{ rotating: isRotating }"
                src="../assets/img/otgame/xz-xx.png"
                style="width: 15px"
              />
            </span>
            <img
              src="../assets/img/otgame/gm-xx.png"
              @click="gotoDep"
              width="28"
              class="m-l-10"
            />
          </div>
          <div
            @click="gotoShare"
            style="
              background: rgba(0, 0, 0, 0.3);
              border-radius: 50%;
              width: 40px;
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <ui-icon name="mail" :size="20" style="color: var(--vk-t1)" />
          </div>
        </div>

        <div v-if="!token" class="xg-btn2" @click="goLogin(0)">
          {{ $lang.Entrar }}
        </div>
        <div v-if="!token" class="xg-btn" @click="goLogin(1)">
          {{ $lang.Registro }}
        </div>
      </div>
    </div>
    <!-- 左侧弹框 -->
    <div>
      <van-popup
        v-model="show"
        class="custom-popup"
        position="left"
        :closeable="false"
        :style="{ width: '80%', height: '100%' }"
        :close-on-click-overlay="true"
      >
        <div class="content">
          <div class="sidedrawer">
            <div class="d-flex">
              <img
                @click="show = false"
                src="../assets/img/otgame/cebianlan_1.png"
                width="20"
                height="18"
              />
              <img
                src="../assets/img/common/logo_h.png"
                height="20"
                class="m-l-10"
              />
              <div class="m-l-20 sidedrawer-top">
                <img
                  :src="
                    require(`@/assets/img/vip/V${
                      InitDate.vipLevel ? InitDate.vipLevel : 0
                    }.png`)
                  "
                  height="22"
                  style="position: absolute"
                />
                <img
                  src="../assets/img/otgame/vipgif.gif"
                  height="22"
                  style="position: absolute"
                />
              </div>
            </div>
            <div class="d-flex-s m-t-10">
              <p class="d-flex nav-con-l" @click="gotoActive(0)">
                <img src="../assets/img/common/home_recharge.png" width="15" />
                <span class="m-l-5">{{ $lang.Depósito }}</span>
              </p>
              <p class="d-flex nav-con-r" @click="gotoActive(1)">
                <img
                  src="../assets/img/common/home_withdrawal.png"
                  width="15"
                />
                <span class="m-l-5">{{ $lang.Saque }}</span>
              </p>
            </div>

          </div>

          <div style="padding: 0 10px 10px 10px">
            <div class="d-flex-s">
              <img
                v-for="(item, index) in drawerGameActivityEntries"
                :key="item.key"
                :src="item.img"
                width="49%"
                @click="goToBBB(index)"
              />
            </div>

            <div
              style="
                background: #313647;
                border-radius: 6px;
                padding: 10px 5px;
                margin-top: 15px;
              "
            >
              <p>{{ $lang.common_txt279 }}</p>
              <div class="d-flex m-t-10">
                <img
                  style="margin-right: 15px"
                  v-for="(item, index) in [
                    require('@/assets/img/otgame/zjm_39.png'),
                    require('@/assets/img/otgame/pinduoduo_24.png'),
                    require('@/assets/img/otgame/ins.png'),
                    require('@/assets/img/otgame/zjm_42.png')
                  ]"
                  :key="index"
                  :src="item"
                  width="34"
                />
              </div>
            </div>

            <div
              style="
                background: #313647;
                border-radius: 6px;
                padding: 10px 5px;
                margin-top: 10px;
              "
            >
              <p>{{ $lang.common_txt280 }}</p>
              <div class="d-flex m-t-10">
                <img
                  style="margin-right: 15px"
                  v-for="(item, index) in [
                    require('@/assets/img/otgame/group-chat.png'),
                    require('@/assets/img/otgame/channel.png')
                  ]"
                  :key="index"
                  :src="item"
                  width="34"
                  @click="goToDDD(index)"
                />
              </div>
            </div>

            <div
              style="
                background: #313647;
                border-radius: 6px;
                padding: 0 10px;
                margin-top: 15px;
              "
            >
              <div
                class="d-flex"
                v-for="(item, index) in mtList"
                :key="index"
                style="padding: 10px 0; border-bottom: 1px solid #232433"
                :class="{ 'no-border-bottom': index === mtList.length - 1 }"
                @click="goToCCC(index)"
              >
                <ui-icon :name="item.glyph" :size="18" />
                <span class="m-l-10">{{ item.name }}</span>
              </div>
            </div>

            <div
              class="d-flex-s"
              style="
                background: #313647;
                border-radius: 6px;
                padding: 10px;
                margin-top: 15px;
              "
              @click="isOpen = !isOpen"
            >
              <div class="d-flex">
                <ui-icon name="globe" :size="16" />
                <span class="m-l-10">{{ GET_COUNTRYNAME }}</span>
              </div>
              <van-icon :name="!isOpen ? 'arrow-down' : 'arrow-up'" />
            </div>
            <div class="selector-content" v-if="isOpen">
              <div class="language-item">English</div>
            </div>

            <div class="foot_img">
              <img src="../assets/img/otgame/dibeijing.jpg" width="100%" />
              <p
                style="
                  text-align: center;
                  text-decoration: underline;
                  color: var(--vk-brand);
                  margin-top: -20px;
                "
              >
                {{ $lang.common_txt286 }} vukavi.com
              </p>
            </div>
          </div>
        </div>
      </van-popup>
    </div>

    <login
      v-model="showPopup"
      closeable
      close-icon="cross"
      overlay
      @close-key="closeValue"
      :loginType="loginType"
    ></login>
    <service-popup v-model="showPopup2" :srcValue="srcValue"></service-popup>
    <lucky-roulette v-model="isShowPopup" overlay></lucky-roulette>
  </div>
</template>
<script>
import {
  Init,
  GameBalanceList,
  GetCsLink,
  GetHomeGameList,
  // GetIsFbReport,
  fbReportSuccess,
  GetLotteryList,
  GetPlatformList,
  WithdrawInit
} from '@/api/common'
import {
  logoutIfReloginRequiredWithToken,
  markReloginRequiredOnPlatformChange
} from '@/utils/platformAuth'
import { safeGetStorageItem, safeLocalStorage, safeSetStorageItem } from '@/utils/safeStorage'
import { getMineActionRoute } from '@/views/layout/mineNavigation'
import {
  entryAt,
  gameActivityEntries,
  topNavUtilityEntries
} from '@/views/layout/navigationEntries'
import {
  isNeedLogin,
  isOkResponse,
  normalizePlatformList,
  responseFailMessage,
  safeArray,
  safeContent,
  safeJsonParse,
  safeNumber,
  safeObject,
  safeString
} from '@/views/layout/safeLayout'
import { customerServiceFailMessage, openCustomerServiceUrl } from '@/views/layout/csLink'
import { copyTextToClipboard } from '@/components/share/shareSafety'
import UiIcon from '@/components/UiIcon.vue' // 通用 UI 线性图标(去蓝→中性)
import { SINGLE_COUNTRY } from '@/config/singleCountry'

const TOPNAV_ENTRY_BLOCKED_MESSAGE = 'This feature is temporarily unavailable. Please try again later.'
const TOPNAV_LOGIN_REQUIRED_MESSAGE = 'This service is temporarily unavailable. Please try again later.'
const GENERIC_FAILURE_MARKER_RE = /routeUnavailable|route_unavailable|readFailure|read_failure|readFailed|read_failed|readBlocked|read_blocked|readUnavailable|read_unavailable|dataUnavailable|data_unavailable|fallbackUsed|fallback_used|backendBlocked|backend_blocked|backendFailure|backend_failure|failClosed|fail_closed|readOnly|read_only|need_login|technicalError|technical_error|technicalException|technical_exception|technicalMarker|technical_marker|技术错误|技术异常/i
const SAFE_PIXEL_QUERY_RE = /^[A-Za-z0-9_.~%+=&-]{1,512}$/
const SAFE_PIXEL_KEY_RE = /^[A-Za-z0-9_.-]{1,64}$/

function hasGenericFailureMarker(data) {
  try {
    return GENERIC_FAILURE_MARKER_RE.test(JSON.stringify(data || {}))
  } catch (e) {
    return false
  }
}

function reloadLocationSafely() {
  try {
    const location = typeof window !== 'undefined' && window ? window.location : null
    if (location && typeof location.reload === 'function') {
      location.reload()
      return true
    }
  } catch (e) {
    return false
  }
  return false
}

function browserWindow() {
  return typeof window !== 'undefined' && window ? window : null
}

function browserDocument() {
  return typeof document !== 'undefined' && document ? document : null
}

function browserLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) {
    return null
  }
  return null
}

function safePixelQuery(value) {
  const query = safeString(value).replace(/^\?+/, '')
  if (!query || !SAFE_PIXEL_QUERY_RE.test(query)) {
    return { query: '', params: {} }
  }
  const params = {}
  query.split('&').forEach((param) => {
    const [rawKey, ...rawValue] = param.split('=')
    const key = safeString(rawKey)
    if (!SAFE_PIXEL_KEY_RE.test(key)) return
    params[key] = safeString(rawValue.join('='))
  })
  return { query, params }
}

export default {
  name: 'TopDownload',
  components: { UiIcon },
  data() {
    return {
      // 单国实例:隐藏顶部国家切换器入口(见 @/config/singleCountry)
      isSingleCountry: !!SINGLE_COUNTRY,
      isOpen: false,
      mtList: [
        {
          ...topNavUtilityEntries[0],
          glyph: 'heart', // 收藏游戏(原 cebianlan_15 蓝)
          name: this.$lang.common_txt281
        },
        {
          ...topNavUtilityEntries[1],
          glyph: 'help', // 帮助/FAQ(原 cebianlan_12 蓝)
          name: this.$lang.common_txt282
        },
        {
          ...topNavUtilityEntries[2],
          glyph: 'headset', // 在线客服(原 cebianlan_13 蓝)
          name: this.$lang.common_txt283
        },
        {
          ...topNavUtilityEntries[3],
          glyph: 'ticket', // 现金券(原 cdk 蓝)
          name: this.$lang.common_txt284
        },
        {
          ...topNavUtilityEntries[4],
          glyph: 'handshake', // 商务合作(原 hezuo)
          name: this.$lang.common_txt285
        }
      ],
      showLang: false,
      showCountryDrop: false,
      countryList: [],
      lotList2: [],
      isShadowVisible: false,
      isShowXl: false,
      isShowPopup: false,
      selectIndex: 0,
      srcValue: '',
      dataList: [],
      loginType: 0,
      timer: null,
      showPopup: false,
      showPopup2: false,
      InitDate: {}, //数据
      InitDate2: {
        balance: 0,
        promoBalance: 0
      }, //数据2
      show: false,
      // closeIcon: require('@/assets/img/common/menu.png'), // 引入本地图片作为关闭图标,
      isRotating: false, // 控制旋转状态
      isService: false,
      whatList: [],
      pgDate: {},
      selectMenIndex: 0
    }
  },
  computed: {
    drawerGameActivityEntries() {
      const images = {
        luckyWheel: require('@/assets/img/otgame/LuckyWheel.png'),
        luckyDraw: require('@/assets/img/otgame/LuckyDraw.png')
      }
      return gameActivityEntries
        .filter((entry) => entry.enabled !== false)
        .map((entry) => ({
          ...entry,
          img: images[entry.key]
        }))
    }
  },
  mounted() {
    const win = browserWindow()
    const doc = browserDocument()
    if (win && typeof win.addEventListener === 'function') {
      win.addEventListener('scroll', this.handleScroll)
    }

    // this.GetHomeGameList()
    // this.GetCsLink()
    // this.$bus.$on('tab-list', (v) => {
    //   this.dataList = v
    //   this.dataList.forEach((i) => {
    //     this.$set(i, 'isShow', false)
    //   })
    // })
    if (this.token) {
      this.Init()
      this.GetGameBalanceList()
      this.$bus.$on('refsh-amount', this.refreshAmount)
    }
    this.ensureCountryInfo()
    if (doc && typeof doc.addEventListener === 'function') {
      doc.addEventListener('click', this.handleOutsideClick)
    }
  },
  beforeDestroy() {
    const win = browserWindow()
    const doc = browserDocument()
    if (win && typeof win.removeEventListener === 'function') {
      win.removeEventListener('scroll', this.handleScroll)
    }

    // this.$bus.$off('tab-list')
    this.$bus.$off('refsh-amount', this.refreshAmount)

    // 解绑全局点击事件
    if (doc && typeof doc.removeEventListener === 'function') {
      doc.removeEventListener('click', this.handleOutsideClick)
    }
  },
  methods: {
    showTopNavToast(payload) {
      if (typeof this.$toast === 'function') {
        this.$toast(payload)
      }
    },
    responseMessage(data, fallback) {
      if (isNeedLogin(data)) return TOPNAV_LOGIN_REQUIRED_MESSAGE
      return responseFailMessage(data, fallback || TOPNAV_ENTRY_BLOCKED_MESSAGE)
    },
    isTopNavEntryOk(data) {
      return !hasGenericFailureMarker(data) && isOkResponse(data)
    },
    resetBalance() {
      this.InitDate2 = {
        balance: 0,
        promoBalance: 0
      }
    },
    refreshAmount() {
      this.GetGameBalanceList()
    },
    toggleCountryDrop() {
      this.showCountryDrop = !this.showCountryDrop
      if (this.showCountryDrop && this.countryList.length === 0) {
        this.fetchCountryList()
      }
    },
    async ensureCountryInfo() {
      // 单国模式:国家/平台信息由 singleCountry 锁死,跳过远程平台列表覆盖(防污染 storage);仅多国模式生效。
      if (SINGLE_COUNTRY) return
      const country = safeGetStorageItem(browserLocalStorage(), 'country')
      if (!country) return
      if (
        safeGetStorageItem(browserLocalStorage(), 'countryName') &&
        safeGetStorageItem(browserLocalStorage(), 'iconUrl')
      ) return
      try {
        const data = await GetPlatformList()
        if (!isOkResponse(data)) return
        const match = normalizePlatformList(data).find((i) => i.country === country)
        if (!match) return
        const prevPlatform = safeGetStorageItem(browserLocalStorage(), 'platform')
        if (markReloginRequiredOnPlatformChange(prevPlatform, match.platform) && this.$bus) {
          this.$bus.$emit('openLogin')
        }
        safeSetStorageItem(browserLocalStorage(), 'countryName', match.countryName || '')
        safeSetStorageItem(browserLocalStorage(), 'iconUrl', match.iconUrl || '')
        safeSetStorageItem(browserLocalStorage(), 'currency', match.currency || '')
        safeSetStorageItem(browserLocalStorage(), 'currencyUnit', match.currencyUnit || '')
        safeSetStorageItem(browserLocalStorage(), 'areaCode', match.areaCode || '')
        safeSetStorageItem(browserLocalStorage(), 'platform', match.platform || '')
        safeSetStorageItem(browserLocalStorage(), 'defaultLanguage', match.defaultLanguage || '')
        this.GET_COUNTRYNAME = match.countryName || ''
        this.GET_ICONURL = match.iconUrl || ''
        this.GET_CURRENCYUNIT = match.currencyUnit || ''
        this.GET_AREACODE = match.areaCode || ''
        this.GET_PLATFORM = match.platform || ''
        this.getCurrency = match.currency || ''
      } catch (e) {
        this.countryList = []
      }
    },
    async fetchCountryList() {
      try {
        const data = await GetPlatformList()
        this.countryList = isOkResponse(data) ? normalizePlatformList(data) : []
      } catch (e) {
        this.countryList = []
      }
    },
    selectCountryNav(item) {
      const platform = safeObject(item)
      if (!platform.country) return
      const prevPlatform = safeGetStorageItem(browserLocalStorage(), 'platform')
      logoutIfReloginRequiredWithToken(prevPlatform, platform.platform)
      safeSetStorageItem(browserLocalStorage(), 'currency', safeString(platform.currency))
      safeSetStorageItem(browserLocalStorage(), 'areaCode', safeString(platform.areaCode))
      safeSetStorageItem(browserLocalStorage(), 'currencyUnit', safeString(platform.currencyUnit))
      safeSetStorageItem(browserLocalStorage(), 'platform', safeString(platform.platform))
      safeSetStorageItem(browserLocalStorage(), 'defaultLanguage', safeString(platform.defaultLanguage))
      safeSetStorageItem(browserLocalStorage(), 'iconUrl', safeString(platform.iconUrl))
      safeSetStorageItem(browserLocalStorage(), 'countryName', safeString(platform.countryName))
      safeSetStorageItem(browserLocalStorage(), 'country', safeString(platform.country))
      this.showCountryDrop = false
      this.$router.replace('/' + platform.country + '/home')
      setTimeout(() => { reloadLocationSafely() }, 200)
    },
    goOpen() {
      this.show = !this.show
      // if (this.show) {
      //   this.GetLotteryList()
      // }
    },
    async GetLotteryList() {
      try {
        const data = await GetLotteryList()
        if (isOkResponse(data)) {
          this.lotList2 = safeArray(safeContent(data).allLotteryList).filter((i) =>
            ['L'].includes(i.freqType)
          )
        } else {
          this.lotList2 = []
        }
      } catch (e) {
        this.lotList2 = []
      }
    },
    goToLotDetail(i) {
      const item = safeObject(i)
      this.$jumpTo('/lotteryDetail', {
        lotteryType: item.lotteryType,
        lotteryName: item.lotteryName
      })
    },
    goToLotDetail3(i) {
      const item = this.lotList2[i]
      if (!item || !item.lotteryType) return
      this.goToLotDetail(item)
    },
    async gotoActive(i) {
      if (!safeGetStorageItem(browserLocalStorage(), 'token')) {
        this.showPopup = true
        return
      }
      if (i === 0) {
        this.$jumpTo('/rechargeCont')
        return
      }
      try {
        const data = await WithdrawInit()
        if (isNeedLogin(data)) {
          this.showTopNavToast({ message: this.responseMessage(data), icon: 'cross' })
          this.showPopup = true
          return
        }
        if (!this.isTopNavEntryOk(data)) {
          this.showTopNavToast({ message: this.responseMessage(data), icon: 'cross' })
          return
        }
        const route = getMineActionRoute('withdraw', {
          loggedIn: true,
          profile: safeContent(data),
          source: 'topNav'
        })
        if (route.requiresLogin) {
          this.showPopup = true
          return
        }
        this.$jumpTo(route.path, route.query || {})
      } catch (e) {
        this.showTopNavToast({ message: this.responseMessage(e && (e.response || e)), icon: 'cross' })
      }
    },

    handleScroll() {
      const win = browserWindow()
      const scrollTop = win ? win.pageYOffset : 0
      this.isShadowVisible = scrollTop > 0
    },
    copyText2() {
      try {
        const copied = copyTextToClipboard(safeString(this.InitDate.inviteCode))
        this.showTopNavToast({
          message: copied ? this.$lang.Sucesso : (this.$lang.copy_failed || 'Copy failed'),
          icon: copied ? 'success' : 'cross'
        })
      } catch (e) {
        const copied = false
        this.showTopNavToast({
          message: copied ? this.$lang.Sucesso : (this.$lang.copy_failed || 'Copy failed'),
          icon: copied ? 'success' : 'cross'
        })
      }
    },
    async GetHomeGameList() {
      try {
        const data = await GetHomeGameList()
        if (!isOkResponse(data)) {
          this.pgDate = {}
          this.dataList = []
          return
        }
        this.pgDate = safeContent(data)
        // 创建一个新数组，将新对象插入到第一个位置

        // 使用 map 和 reduce 合并 types 数组
        const typesArr = safeArray(this.pgDate.dataList).reduce(
          (acc, item) => acc.concat(safeArray(item && item.types)),
          []
        )

        const newList = [
          {
            name: 'Lobby',
            icon: require('@/assets/img/common/all_home.png'),
            types: typesArr
          },
          ...safeArray(this.dataList)
        ]

        this.dataList.splice(0, this.dataList.length, ...newList) // 替换原数组

        this.dataList.forEach((i) => {
          i.types = safeArray(i.types).sort((a, b) => safeNumber(a && a.order) - safeNumber(b && b.order))
        })

        let newArr = safeArray(this.dataList[0] && this.dataList[0].types).filter((i) => i.code === '3000602')
        this.isOtgame = newArr.flatMap((item) =>
          safeArray(item && item.games).filter((game) => game.gameName === 'Lucky Ball')
        )
        let newDataList = safeArray(this.dataList[0] && this.dataList[0].types).map((item) => ({ ...item }))
        this.dataList[0].homeIcon = require('@/assets/img/common/all_home.png')
        // 使用 Vue.set 确保响应式更新
        for (let i = 0; i < newDataList.length; i++) {
          this.$set(this.dataList, i + 1, {
            homeIcon: newDataList[i].homeIcon,
            icon: newDataList[i].icon,
            name: newDataList[i].name,
            types: [newDataList[i]]
          })
        }
      } catch (e) {
        this.pgDate = {}
        this.dataList = []
      }
    },
    toggleDropdown() {
      this.isShowXl = !this.isShowXl
    },
    closeDropdown() {
      this.isShowXl = false
    },
    handleOutsideClick(event) {
      // 判断点击位置是否在下拉框组件内部
      const dropdownRef = this.$refs.dropdownRef
      if (dropdownRef && !dropdownRef.contains(event.target)) {
        this.closeDropdown()
      }
    },
    goToSaque() {
      return this.gotoActive(1)
    },
    goToRegistro() {
      this.$jumpTo('/recordOrder')
    },
    goToRecord() {
      this.$jumpTo('/recordOrder')
    },
    // goToShare() {
    //   if (this.$route.path === '/share') {
    //   } else {
    //     this.$router.push('./share')
    //   }
    // },
    goProtectedActivity(path) {
      if (!safeGetStorageItem(browserLocalStorage(), 'token')) {
        this.showPopup = true
        return false
      }
      this.$jumpTo(path)
      this.show = false
      return true
    },
    openNavigationEntry(entry) {
      if (!entry || !entry.route) return false
      if (entry.requiresLogin) return this.goProtectedActivity(entry.route)
      this.$jumpTo(entry.route)
      this.show = false
      return true
    },
    goToDetail(i) {
      if (i === 0) {
        if (!safeGetStorageItem(browserLocalStorage(), 'token')) {
          this.showPopup = true
        } else {
          this.isShowPopup = true
        }
      } else if (i === 1) {
        this.goProtectedActivity('/vipSignIn')
      } else if (i === 2) {
        this.goProtectedActivity('/activityFistRecharge')
      } else if (i === 3) {
        this.goProtectedActivity('/referFriend')
      } else if (i === 4) {
        this.goProtectedActivity('/redPacket')
      } else if (i === 5) {
        this.goProtectedActivity('/cashBack')
      } else if (i === 6) {
        this.goProtectedActivity('/signIn')
      }
    },
    goHome() {
      if (this.$route.path.includes('/home')) {
        // window.location.reload()
      } else {
        this.$jumpTo('/home', {}, { replace: true })
      }
    },
    getSelect(v) {
      this.selectIndex = v
      // if (this.$route.path === '/home') {
      //   this.$bus.$emit('message-sent', v)
      // } else {
      //   this.$router.push({ path: '/home', query: { gameTab: v } })
      //   this.$bus.$emit('message-sent', v)
      // }
      this.$jumpTo('/category', { gameTab: v })
      this.show = false
    },
    // async GetHomeGameList() {
    //   const data = await GetHomeGameList()
    //   if (data.status === 'ok') {
    // this.dataList = data.content.dataList
    // this.dataList.forEach((i) => {
    //   this.$set(i, 'isShow', false)
    // })
    //   }
    // },
    goLogin(v) {
      this.loginType = v
      this.showPopup = true
    },
    async GetCsLink() {
      try {
        const data = await GetCsLink()
        const url2 = safeArray(safeContent(data).url2)
        if (url2.some((item) => 'tg' in safeObject(item))) {
          this.isService = true
          this.whatList = url2
        } else {
          this.isService = false
          this.whatList = []
        }
      } catch (e) {
        this.isService = false
        this.whatList = []
      }
    },
    closeValue() {
      this.Init()
      reloadLocationSafely()
    },
    // goDetail(i) {
    //   if (i === 0) {
    //     const targetKey3 = 'tg'
    //     window.open(
    //       this.whatList.find((item) => targetKey3 in item)?.[targetKey3],
    //       '_blank'
    //     )
    //   }
    // },
    goToBBB(i) {
      this.openNavigationEntry(entryAt(this.drawerGameActivityEntries, i))
    },
    goToCCC(i) {
      this.openNavigationEntry(entryAt(this.mtList, i))
    },
    async openTopNavCustomerService() {
      let message = this.$lang.feature_unavailable || 'This feature is temporarily unavailable. Please try again later.'
      try {
        const data = await GetCsLink()
        if (openCustomerServiceUrl(data, 'telegram')) return
        message = customerServiceFailMessage(data, message)
      } catch (e) {
        message = customerServiceFailMessage(e, message)
      }
      this.showTopNavToast({
        message,
        icon: 'cross'
      })
    },
    goToDDD(i) {
      if (i === 0) {
        this.openTopNavCustomerService()
      } else if (i === 1) {
        this.openTopNavCustomerService()
      }
    },
    gotoGame2(i) {
      if (i === 0) {
        this.$jumpTo('/activityFistRecharge')
      } else if (i === 1) {
        this.$jumpTo('/activityCooperate')
      } else if (i === 2) {
        this.$jumpTo('/signIn')
      } else if (i === 3) {
        if (!this.token) {
          this.$emit('getLoging')
        } else {
          this.$jumpTo('/vip')
        }
      }
      this.show = false
    },
    // gotoGame(i) {
    //   this.$bus.$emit('message-sent', i)
    //   this.show = false
    // },
    async GetGameBalanceList() {
      try {
        const data = await GameBalanceList()
        if (isNeedLogin(data)) {
          this.resetBalance()
          return
        }
        if (!isOkResponse(data)) {
          this.resetBalance()
          return
        }
        const content = safeContent(data)
        this.InitDate2 = {
          ...content,
          balance:
            content.balance || content.totalBalance || content._balUsable || 0,
          promoBalance: content.promoBalance || 0
        }
      } catch (e) {
        this.resetBalance()
      }
    },
    async fbReportSuccess() {
      try {
        await fbReportSuccess()
      } catch (e) {
        return false
      }
    },
    // async GetIsFbReport(v) {
    //   const data = await GetIsFbReport({
    //     inviteCode: safeGetStorageItem(browserLocalStorage(), 'id')
    //   })
    //   if (data.status === 'ok') {
    //     if (data.content.isReport) {
    //       if (data.content.target === 'ks') {
    //         window.kwaiq.load(data.content.fbPixId)
    //         window.kwaiq.instance(data.content.fbPixId).track('purchase', {
    //           amount: v * 0.1,
    //           currency: 'BRL'
    //         })
    //         // window.kwaiq.track('purchase', {
    //         //   amount: v * 0.1,
    //         //   currency: 'BRL'
    //         // })
    //         this.fbReportSuccess()
    //       } else {
    //         this.$pixel.setFbId(data.content.fbPixId)
    //         this.$pixel.callTrackHasPara('track', 'Purchase', v * 0.1, 'BRL') // 上报
    //         const jsonData = `"""{"data":[{"event_name": "Purchase", "value": ${
    //           v * 0.1
    //         }, "currency": "BRL","content_type": "product"}]}"""`
    //         this.$pixel.sendEventToAndroid(jsonData)
    //         this.fbReportSuccess()
    //       }
    //     }
    //   }
    // },
    // 加载数据
    async Init() {
      try {
        const data = await Init()
        if (isNeedLogin(data)) {
          this.InitDate = {}
          return
        }
        if (!isOkResponse(data)) return

        const content = safeContent(data)
        this.InitDate = content
        if (content.inviteCode) {
          safeSetStorageItem(browserLocalStorage(), 'shareCode', content.inviteCode)
        }

        const pixelConfig = safeJsonParse(content.fbPixJson, {})
        if (!pixelConfig.pixIsSend || pixelConfig.pixIsSend !== 1 || !pixelConfig.fbUrlPara) {
          return
        }

        const pixelQuery = safePixelQuery(pixelConfig.fbUrlPara)
        if (!pixelQuery.query) return

        this.$jumpTo('?' + pixelQuery.query, {}, { replace: true })
        const params = pixelQuery.params
        const purchaseValue = parseInt(safeNumber(pixelConfig.firstDepositAmount) * 0.1)
        const reportCurrency = safeGetStorageItem(browserLocalStorage(), 'currency') || (SINGLE_COUNTRY && SINGLE_COUNTRY.currency) || 'XOF'

        const win = browserWindow()
        const kwaiq = win && win.kwaiq ? win.kwaiq : null
        if (
          params['target'] === 'ks' &&
          kwaiq &&
          typeof kwaiq.load === 'function' &&
          typeof kwaiq.instance === 'function'
        ) {
          kwaiq.load(params['fbid'])
          const tracker = kwaiq.instance(params['fbid'])
          if (tracker && typeof tracker.track === 'function') {
            tracker.track('purchase', {
              amount: purchaseValue,
              currency: reportCurrency
            })
            this.fbReportSuccess()
          }
          return
        }

        const pixel = this.$pixel || null
        if (params['target'] === 'fb' && pixel && win && typeof win.fbq === 'function') {
          if (typeof pixel.setFbId === 'function') {
            pixel.setFbId(params['fbid'])
          }
          win.fbq('track', 'Purchase', {
            value: purchaseValue,
            currency: reportCurrency,
            event_time: Date.now(),
            event_id: `ORDER${content._uid || ''}`,
            user_data: {
              fbc: params['fbclid']
            },
            custom_data: {
              value: purchaseValue,
              currency: reportCurrency
            }
          })
          const jsonData = `"""{"data":[{"event_name": "Purchase", "value": ${purchaseValue}, "currency": "${reportCurrency}","content_type": "product"}]}"""`
          if (typeof pixel.sendEventToAndroid === 'function') {
            pixel.sendEventToAndroid(jsonData)
          }
          this.fbReportSuccess()
        }
      } catch (e) {
        this.InitDate = {}
      }
    },
    gotoShare() {
      this.$jumpTo('/email')
      // if (this.$route.name !== 'Recharge') {
      //   this.$router.push('/recharge')
      // }
    },
    InviteGo() {
      this.$jumpTo('/share')
    },
    // copyText() {
    //   const textarea = document.createElement('textarea')
    //   textarea.value = this.InitDate.inviteCode
    //   document.body.appendChild(textarea)
    //   textarea.select()
    //   document.execCommand('copy')
    //   document.body.removeChild(textarea)
    //   this.$toast({
    //     message: 'Success',
    //     icon: 'success'
    //   })
    // },
    toggleRotation() {
      if (this.isRotating) return // 如果已经在旋转，直接返回
      this.isRotating = true
      // 动画结束后重置状态
      setTimeout(() => {
        this.isRotating = false
      }, 1000) // 动画持续时间
      this.GetGameBalanceList()
      this.timer++
    },
    gotoDep() {
      if (safeGetStorageItem(browserLocalStorage(), 'token')) {
        this.$jumpTo('/rechargeCont')
      } else {
        this.showPopup = true
      }
    }
  },
  watch: {
    $route() {
      // 路由变化时关闭弹窗
      this.show = false
    }
  }
}
</script>
<style lang="less" scoped>
.topnav-country-wrap {
  position: relative;
}
.topnav-country-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 200px;
  z-index: 200;
  background: #252936;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  max-height: 220px;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  margin-top: 4px;

  &__item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    cursor: pointer;
    font-size: var(--vk-fs-sm);
    color: #ffffff;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);

    &:last-child { border-bottom: none; }
    &:active { background: rgba(36, 238, 137, 0.1); }
  }
}
.selector-content {
  background: #171824;
  padding: 0 10px;
  border-radius: 6px;
  .language-item {
    padding: 10px 20px;
  }
}
.no-border-bottom {
  border-bottom: none !important;
}
.sidedrawer {
  background: url(../assets/img/otgame/bj.png) no-repeat;
  background-size: 100% 100%;
  padding: 10px;
  // height: 150px;
  align-items: flex-start;
}
.sidedrawer-top {
  position: relative;
  height: 22px;
}
.nav-cont {
  width: 100%;
  max-width: var(--vk-pc-col);
  height: 60px;
  background: #ffffff;
  background: url(../assets/img/menu_bg.png) no-repeat;
  background-size: cover;
  display: flex;
  // align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1999;
  padding-top: 2px;
  margin: 0 auto;
  box-sizing: border-box;
  // box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
}
.nav-cont > .d-flex-s {
  min-width: 0;
  flex-wrap: nowrap;
}
// .shadow {
//   background: url('../assets/img/home/bg-show.png') no-repeat !important;
//   background-size: 100% 100% !important;
// }
.nav--coo {
  // width: 35%;
  margin-left: 10px;
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1 1 auto;
  gap: 6px;
}
.nav--coo > img {
  flex-shrink: 0;
}
.topnav-country-wrap {
  position: relative;
  min-width: 0;
  flex-shrink: 1;
}
.topnav-country-wrap > .d-flex > span {
  max-width: 90px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nav--gn {
  background-image: url('../assets/img/common/menu.png'); /* 指定背景图片的路径 */
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 20px; /* 或者指定具体的宽度 */
  height: 18px;
}
.nav--log {
  background-image: url('../assets/img/common/logo_h.png'); /* 指定背景图片的路径 */
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 86px; /* 或者指定具体的宽度 */
  height: 15px;
}
.nav--coe {
  display: flex;
  align-items: center;
  // width: 65%;
  justify-content: right;
  margin-right: 10px;
  flex-shrink: 0;
}
.nav--ct {
  // height: 25px;
  // border-radius: 32px;
  // padding: 3px 2px 3px 0;
  display: flex;
  // border: 1px solid @border-color; /* 白色边框 */
  align-items: center;
  // .nav--ct-l {
  //   width: 15px;
  //   height: 15px;
  //   border-radius: 50%;
  //   background-color: @primary-color;
  //   text-align: center;

  // }
}

.nav--r {
  margin-left: 10px;
  padding: 5px 9px 3px;
  background: var(--vk-brand); /* 黄绿→火焰橙(铁律⑤) */
  border-radius: 6px;
  text-align: center;
}
/* 定义旋转动画 */
@keyframes rotate-and-back {
  0%,
  100% {
    transform: rotate(0deg); /* 初始和最终状态 */
  }
  50% {
    transform: rotate(360deg); /* 顺时针旋转360度 */
  }
}

/* 动画类 */
.rotating {
  animation: rotate-and-back 1s linear forwards; /* 4秒完成动画，线性过渡，动画结束后保留状态 */
}
.vk-touch-44 {
  /* a11y:44×44 触控热区(WCAG 2.5.5),负 margin 抵消占位,视觉尺寸不变 */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin: -14px;
  cursor: pointer;
}
.custom-popup {
  // padding-top: 5px;
  padding-bottom: 3%;
  background-color: #212234; /* 设置背景色 */
  // background: url(../assets/img/common/homev2_menu_bg.png) no-repeat;
  background-size: 100% 100%;
  height: 100%;
  width: 100%;
  // margin-top: 50px;
}
// ::v-deep .van-overlay {
//   height: 94% !important;
//   margin-top: 50px;
// }
// .van-popup--left {
//   top: 47%;
// }
// .content {
//   width: 100%;
//   padding: 0 10px;
// }
.content-avatar {
  position: relative;
  width: 100%;
  text-align: center;
}
.content-avatar-a {
  width: 100px;
  height: 100px;
}
.content-avatar-b {
  width: 33px;
  height: 30px;
  position: absolute;
  top: 65px;
  right: 113px;
}
.content-two {
  display: flex;
  justify-content: space-between;
}
.content-two--button {
  width: 48%;
  border-radius: 10px;
  font-size: var(--vk-fs-15);
  font-weight: bold;
}
.van-button__icon {
  font-size: var(--vk-fs-2xl);
  right: 8px;
}
.content-three {
  margin-top: 5px;
  flex-flow: wrap row;
  text-align: center;
}
.content-three-list {
  font-weight: bold;
  background: #2a3546;
  border-radius: 10px;
  margin-bottom: 5px;
  color: @font-color;
  width: 48%;
  padding: 8px 0;
  text-align: center;
  box-shadow: 0 0px 1px 1px rgba(0, 0, 0, 0.2); /* 四周黑色阴影 */

  // .content-three-list--i {
  //   background: @background-color;
  //   padding: 5px 10px;
  //   margin-bottom: 5px;
  //   border-radius: 10px;
  // }
}
.content-four {
  font-weight: bold;
  background: @cont-bg;
  padding: 15px 12px 15px;
  border-radius: 10px;
  margin-top: 15px;
}
.content-four--list {
  padding: 12px 0;
  display: flex;
  align-items: center;
}
.buttoncustom- {
  padding: 16px 10px 15px !important; /* 增加内边距 */
  font-size: var(--vk-fs-xs); /* 设置字体大小 */
  border-radius: 9px;
  margin-right: 6px;
  border: none !important;
}
.active-select {
  background: @primary-color3; /* =@brand 火焰橙(铁律①激活) */
  color: var(--vk-bg); /* 深字(WCAG AA;原白字对比不足) */
}
.balance-text {
  // color: #ffcd28; /* 设置文字颜色 */
  font-size: var(--vk-fs-sm); /* 设置文字大小 */
  margin-right: 6px;
  // color: #1d567d;
}

.tran-xz {
  transform: rotate(180deg);
}
.nav-btn {
  width: 100%;
  padding: 10px 45px 10px 20px;
  border-radius: 5px;
  background: #2a3546;
  box-shadow: 0 0px 1px 1px rgba(0, 0, 0, 0.2); /* 四周黑色阴影 */
}
.activi-hd {
  background: #2a3546;
  padding: 5px;
  border-radius: 5px;
}
.triangle {
  width: 0; /* 宽度为0 */
  height: 0; /* 高度为0 */
  border-left: 4px solid transparent; /* 左边框透明 */
  border-right: 4px solid transparent; /* 右边框透明 */
  border-top: 7px solid; /* 底边框为红色 */
}

.triangle-xz {
  border-top: none; /* 底边框为红色 */
  border-bottom: 7px solid; /* 底边框为红色 */
}
.cz-xl {
  background: linear-gradient(to bottom, #ef6279, #d32144, #d32144, #d32144);
  box-shadow: 0 0 5px rgba(211, 33, 68, 1); /* 阴影效果 */
  border-bottom: 2px solid #80132b !important;
  border-radius: 15px;
  padding: 5px;
  font-size: var(--vk-fs-xs);
  position: relative;
}
.cz-xlx {
  position: absolute;
  font-size: var(--vk-fs-2xs);
  background: @cont-bg;
  border-radius: 10px;
  padding: 3px;
  top: 25px;
  width: 100%;
  right: 1px;
  p {
    padding: 5px;
  }
}
.custom-button {
  height: 30px;
  padding: 0 10px;
  border-radius: 8px !important;
  font-weight: 100 !important;
  width: 82px;
  font-size: var(--vk-fs-xs) !important;
}
/* 注册=火焰橙实心(主 CTA) */
.xg-btn {
  background: var(--vk-grad);
  font-weight: bold !important;
  height: 30px;
  width: 70px;
  color: var(--vk-bg); /* 深字 on 火焰橙,WCAG AA */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--vk-r-sm);
}
/* 登录=幽灵(次 CTA,火焰橙描边) */
.xg-btn2 {
  background: transparent;
  font-weight: bold !important;
  margin-right: 10px;
  height: 30px;
  width: 70px;
  color: var(--vk-brand);
  border: 1px solid var(--vk-brand);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--vk-r-sm);
}
.nav-cont-t {
  margin-top: 20px;
  background: var(--vk-surface); /* 紫底→中性面(铁律⑤) */
  padding: 10px;
  border-radius: 12px;
}
.nav-con-l {
  width: 48%;
  justify-content: center;
  padding: 6px 0;
  border-radius: 6px;
  background-image: var(--vk-grad); /* 存款=火焰橙 CTA(对齐 mine/menu) */
  padding: 10px;
}
.nav-con-r {
  width: 48%;
  justify-content: center;
  padding: 6px 0;
  border-radius: 6px;
  background: transparent; /* 提现=幽灵(去蓝渐变) */
  border: 1px solid var(--vk-border);
  padding: 10px;
}
.nav-coe-ll {
  color: #ffffff;
  border-radius: 8px;
  margin-right: 10px;
  padding: 5px 6px;
}
.select-Men {
  background: var(--vk-brand) !important; /* 激活=火焰橙(铁律①,去蓝) */
  color: #ffffff !important;
}
.men-i {
  width: 48%;
  text-align: center;
  color: #3a71b1;
  font-weight: bold;
  background: #ffffff;
  border-radius: 10px;
  padding: 5px 0;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);
}
/* PC 端样式 */
@media (min-width: 769px) {
  .custom-popup {
    width: 336px !important;
    left: 56%;
    transform: translate(-112%, -50%);
    padding-top: 0px !important;
    padding-bottom: 0 !important;
    // margin-top: 38px;
    height: 100% !important;
  }
  ::v-deep .van-overlay {
    height: 100% !important;
  }
}
</style>
